// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#organizationContainer {
	height: calc(100vh - (2*1.5rem + 1.25rem + 0.5rem + 0.5rem + 2rem + 3rem));
}

@media (max-width: 767.98px) {
	#organizationDetailsColumn {
		display: none;
		position: absolute;
		right: -100%;
		transition: all .3s;
	}

	#organizationDetailsColumn.organization-selected {
		display: block;
		right: 0;
	}

}`, "",{"version":3,"sources":["webpack://./src/views/organization/style.css"],"names":[],"mappings":"AAAA;CACC,0EAA0E;AAC3E;;AAEA;CACC;EACC,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,QAAQ;CACT;;AAED","sourcesContent":["#organizationContainer {\r\n\theight: calc(100vh - (2*1.5rem + 1.25rem + 0.5rem + 0.5rem + 2rem + 3rem));\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n\t#organizationDetailsColumn {\r\n\t\tdisplay: none;\r\n\t\tposition: absolute;\r\n\t\tright: -100%;\r\n\t\ttransition: all .3s;\r\n\t}\r\n\r\n\t#organizationDetailsColumn.organization-selected {\r\n\t\tdisplay: block;\r\n\t\tright: 0;\r\n\t}\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
